import React from 'react';
import {AddIcon} from '../../icons';
import {useTranslation} from '../../../../hooks/useTranslation';

import './index.scss';
import {useDispatch} from 'react-redux';
import {addField, setFieldsId} from '../../service/createForm.slice';
import {INPUT_FIELD} from '../../fields/staticData';

function AddField() {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const handleAddField = () => {
    dispatch(
      addField({
        field: INPUT_FIELD,
      }),
    );

    dispatch(setFieldsId());
  };

  return (
    <div className='f-build__add' onClick={handleAddField}>
      <span className='f-build__add-icon'>
        <AddIcon />
      </span>
      <span className='f-build__add-text'>{t('createNewForm.components.addField')}</span>
    </div>
  );
}

export default AddField;
